export const QA_NAME_VIEWING_PROFILE_RESCHEDULE_HISTORY =
  'viewingProfileRescheduleHistory'
